// 布撤防（EVT-05）：家戶的模式（在家 / 夜間 / 外出），ADR-011 §4.1 唯一寫入口 PUT /v1/homes/{id}/armed-mode。
// 模式影響「警報」分級（採集當下的模式 × 這台 × 類別有沒有設警報，EVT-02）與通知。owner / admin / member 可切，其他唯讀。
// 回應裡設備沒同步的（離線 / 還在送）數量顯示出來，上線時平台會補推。
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { kinioFetch, planeBase, type KinioHome } from '@kinio/web-sdk';

const MODES = ['home', 'night', 'away'] as const; // 一律小寫（platform#78）

export function ArmedControl({ home, current }: { home: KinioHome; current?: string }) {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState<string | null>(null);
  const can = home.role === 'owner' || home.role === 'admin' || home.role === 'member';
  const set = async (m: string) => {
    setBusy(true);
    setNote(null);
    try {
      const r = await kinioFetch<{ things?: { status: string }[] }>(
        `${planeBase(home.endpoints.api)}/v1/homes/${encodeURIComponent(home.home_id)}/armed-mode`,
        {
          method: 'PUT',
          body: { armed_mode: m },
        },
      );
      const unsynced = (r?.things ?? []).filter((x) => x.status !== 'pushed').length;
      setNote(unsynced ? t('armed.unsynced', { count: unsynced }) : null);
      await qc.invalidateQueries({ queryKey: ['home', home.home_id] });
    } catch (e) {
      setNote(String((e as { code?: string }).code ?? e));
    } finally {
      setBusy(false);
    }
  };
  const cur = (current || 'home').toLowerCase();
  return (
    <span className="armed-control" data-armed={cur}>
      <span className="seg" role="group" aria-label={t('armed.label')}>
        {MODES.map((m) => (
          <button key={m} aria-pressed={cur === m} disabled={!can || busy} onClick={() => cur !== m && void set(m)}>
            {t(`armed.${m}`)}
          </button>
        ))}
      </span>
      {note && <span className="small muted">{note}</span>}
    </span>
  );
}
